import { useAuth } from 'src/auth'

export const isWingworkUser = () => {
  const { currentUser } = useAuth()
  const email = currentUser?.email ?? ''
  if (typeof email === 'string') {
    return email.endsWith('@getwingwork.com')
  }
  return false
}

export const isProductionInstance = () => {
  return window.location.pathname === 'app.wingwork.com'
}

export const isDevelopmentInstance = () => {
  return window.location.pathname === 'dev.wingwork.com'
}

export const isDemoInstance = () => {
  return window.location.pathname === 'demo.wingwork.com'
}
